// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function balotoOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'baloto',
    payment_type_code: 'baloto',
    instalments: '1',
  };
}
